// Copyright (C) 2023 Cochise Ruhulessin
//
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
import { IAccount } from "../../../api"
import { useAccount } from "../context"



interface ConditionalFeatureProps {
  account: IAccount
  available: string[]
  children?: React.ReactNode
  anyOf?: string[]
  stage?: string
}


const ConditionalFeature: React.FC<ConditionalFeatureProps> = ({account, available, ...props}) => {
  const anyOf: RegExp[] = (props.anyOf || []).map((pattern) => {
    return new RegExp(pattern.replace(/\*/, "[a-z]+"))
  })
  const granted = available.filter((g) => {
    return (!!anyOf) ? anyOf.map((p) => p.test(g)).length > 0 : true
  })

  const stage = props.stage || "GA"
  if (!account.canUse(stage)) {
    return null
  }

  if (granted.length === 0) {
    return null
  }

  return (<>{props.children}</>)
}


export { ConditionalFeature }